import { Routes } from '@angular/router';

export const displayCardsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./display-cards.page').then((m) => m.DisplayCardsPage),
  },
];
